import type { FlexProps, StackProps } from '@chakra-ui/react';
import { Box, Center, Image, Stack, Text } from '@chakra-ui/react';
import type { TSignature } from '@ui/locales/config';
import { useTranslations } from 'next-intl';
import type { ReactNode } from 'react';

export interface StepItem {
  title: (t: TSignature) => string;
  image: string;
  addition?: ReactNode;
}

export const StepList = ({
  steps,
  ...props
}: { steps: StepItem[] } & StackProps) => {
  const t = useTranslations();
  return (
    <Stack gap="5" mt="5" {...props}>
      {steps.map((item, index) => {
        return (
          <Stack key={item.image} gap="1">
            <Text textStyle="body3">
              {index + 1}. {item.title(t)}
            </Text>
            <StepItemContainer
              image={item.image}
              title={item.title(t)}
              addition={item.addition}
            />
          </Stack>
        );
      })}
    </Stack>
  );
};

export const StepItemContainer = ({
  image,
  title,
  addition,
  ...props
}: Omit<StepItem, 'title'> & FlexProps) => {
  return (
    <Center {...props}>
      <Box pos="relative">
        <Image src={image} w="200px" alt={title} rounded="16px" />
        {addition}
      </Box>
    </Center>
  );
};
